import { v4 as uuidv4 } from "uuid";
import { base32 } from "@scure/base";
function getFileExtension(filename: string) {
  // 使用lastIndexOf('.')获取文件名中最后一个点的位置
  var index = filename.lastIndexOf(".");
  // 如果点的位置小于0，则表示没有后缀名
  if (index < 0) return "";
  // 使用substring方法获取从点之后的字符串作为后缀名
  return filename.substring(index);
}

export function isPhone(phone: string): boolean {
  return /^1[3456789]\d{9}$/.test(phone);
}
export function isEmail(email: string): boolean {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
}

export function clearAllCookies() {
  var keys = document.cookie.match(/[^ =;]+(?==)/g);
  if (keys) {
    for (var i = keys.length; i--; ) {
      document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString() + ";max-age=0";
    }
  }
}

export function setCSRFFromCookie() {
  if (typeof document !== "undefined" && typeof document.cookie !== "undefined") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith("MMCSRF=")) {
        // Client4.setCSRF(cookie.replace('MMCSRF=', ''));
        break;
      }
    }
  }
}

/**
 * canvas toDataURL to File
 */
export function dataURLtoFile(dataURL: string, fileName: string): File {
  const uint8 = getUint8Arr(dataURL);
  return new File([uint8.uintArray], fileName, { type: uint8.mime });
}

const getUint8Arr = (dataURL: string) => {
  // 截取base64的数据内容
  var binary = atob(dataURL.split(",")[1]);
  var mime = dataURL.split(",")[0].split(":")[1].split(";")[0];
  // 创建一个Uint8Array类型的数组以存放二进制数据
  var uintArray = new Uint8Array(binary.length);
  // 将二进制数据存入Uint8Array类型的数组中
  for (var i = 0; i < binary.length; i++) {
    uintArray[i] = binary.charCodeAt(i);
  }
  return { uintArray, mime };
};

export const blobToDataURL = (blob: Blob): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (_e) => resolve(reader.result as string);
    reader.onerror = (_e) => reject(reader.error);
    reader.onabort = (_e) => reject(new Error("Read aborted"));
    reader.readAsDataURL(blob);
  });
};

export const areAnyPixelsBlack = (pixels: Uint8ClampedArray) => {
  const len = pixels.length;
  let i = 0;
  for (i; i < len; ) {
    if (pixels[i++] === 0 && pixels[i++] === 0 && pixels[i++] === 0 && pixels[i++] === 255) {
      return true;
    }
  }
  return false;
};

export const getImageDataTransparency = (pixels: Uint8ClampedArray) => {
  let isFullyTransparent = true;
  let isPartiallyTransparent = false;
  const len = pixels.length;
  let i = 3;
  for (i; i < len; i += 4) {
    if (pixels[i] === 255) {
      isFullyTransparent = false;
    } else {
      isPartiallyTransparent = true;
    }
    if (!isFullyTransparent && isPartiallyTransparent) {
      return { isFullyTransparent, isPartiallyTransparent };
    }
  }
  return { isFullyTransparent, isPartiallyTransparent };
};

export const downloadBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  a.remove();
};

export const copyBlobToClipboard = (blob: Blob) => {
  navigator.clipboard.write([
    new ClipboardItem({
      [blob.type]: blob,
    }),
  ]);
};

export const newId = () => {
  const uuid = uuidv4();
  const data2 = new TextEncoder().encode(uuid.replaceAll("-", ""));
  return base32.encode(data2).substring(0, 26).toLowerCase();
};

// 使用映射
export const translate = (value: string): string => {
  const generateType:Record<string,string> = {
    decoration: "室内设计",
    architecture: "建筑设计",
    landscape: "景观设计",
    plane: "规划设计",
    general: "其他",
  };
  const keys = Object.keys(generateType);
  return keys.find(key => generateType[key] === value) || "";
};
